import React from 'react';
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import { managementTeam } from "../Data/siteData"

const ManagementTeam: React.FC = () => {
  const teamMembers = managementTeam;

  return (
    <div className="management-team-container">
      <div className="content">
        <h1>Management Team</h1>
        <Row gutter={[16, 16]} justify="center">
          {teamMembers.map((member, index) => (
            <Col xs={24} sm={12} md={6} key={index} className="avatar-column">
              <Link to="/profile" state={member}>
                <div className="avatar-item">
                  <img src={member.src} width={140} style={{ margin: '10' }} />
                  <div><strong>{member.name}</strong></div>
                  <div>{member.title}</div>
                </div>
              </Link>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default ManagementTeam;
